module.exports = __webpack_public_path__ + "media/images/icons/country_flags/mt-ffc20beba9ff8648a176f9158e6a1310.svg";